import React from "react";
import PropTypes from "prop-types";

import s from "./Widget.module.scss";
import classNames from "classnames";

const Widget = (props) => {
  const {
    title = null,
    className = "",
    headerClass = "",
    children = [],
    // options = {},
    ...attributes
  } = props;

  return (
    <React.Fragment>
      <section className={s.widget} {...attributes}>
        {title && (
          <div className={classNames(headerClass, s.title)}>{title}</div>
        )}
        <div className={className}>{children}</div>
      </section>
    </React.Fragment>
  );
};

Widget.propTypes = {
  title: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  options: PropTypes.object,
};

export default Widget;

// ThemedTable: opinionated, theme-aware table wrapper
export const ThemedTable = ({ columns = [], data = [], renderRow, className = "", style = {} }) => {
  const resolvedStyle = {
    width: "100%",
    borderCollapse: "collapse",
    background: "var(--table-bg)",
    color: "var(--text-high, rgba(255,255,255,0.87))",
    border: "1px solid var(--table-border)",
    fontSize: "0.95rem",
    ...style,
  };

  return (
    <table className={className} style={resolvedStyle}>
      {columns.length > 0 && (
        <thead>
          <tr style={{ background: "#000", color: "#fff" }}>
            {columns.map((col, idx) => (
              <th key={idx} style={{ padding: "8px", textAlign: col.align || "left", borderBottom: "1px solid var(--table-border)" }}>
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {renderRow
          ? data.map((row, idx) => (
              <tr key={idx} style={{ borderBottom: "1px solid var(--table-border)", color: "var(--text-high, rgba(255,255,255,0.87))" }}>
                {renderRow(row)}
              </tr>
            ))
          : null}
      </tbody>
    </table>
  );
};

// FormField: label + input slot + help/error, theme-aware
export const FormField = ({
  label,
  htmlFor,
  help,
  error,
  children,
  labelWidth,
  className = "",
  style = {},
}) => {
  const baseStyle = {
    marginBottom: "12px",
    ...style,
  };
  const labelStyle = {
    display: "block",
    marginBottom: 6,
    color: "var(--text-high, rgba(255,255,255,0.87))",
    width: labelWidth,
  };
  const helpStyle = { color: "var(--text-med, rgba(255,255,255,0.60))", marginTop: 4, fontSize: 12 };
  const errorStyle = { color: "#FF7A7A", marginTop: 4, fontSize: 12 };

  return (
    <div className={className} style={baseStyle}>
      {label && (
        <label htmlFor={htmlFor} style={labelStyle}>
          {label}
        </label>
      )}
      <div>{children}</div>
      {error ? <div style={errorStyle}>{error}</div> : help ? <div style={helpStyle}>{help}</div> : null}
    </div>
  );
};